import { render, staticRenderFns } from "./AscReportSingleValue.vue?vue&type=template&id=45daab6c&scoped=true&"
import script from "./AscReportSingleValue.vue?vue&type=script&lang=js&"
export * from "./AscReportSingleValue.vue?vue&type=script&lang=js&"
import style0 from "./AscReportSingleValue.vue?vue&type=style&index=0&id=45daab6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45daab6c",
  null
  
)

export default component.exports